/** 
*@description:事件节流
*@param {Function} 需要节流的函数
*@param {Number} 节流的时间
*@return {Function}
**/
function throttling(fn, delay = 5) {
    let lastTime = 0;
    return function () {
        let args = arguments
        let now = +new Date();
        if (now - lastTime > delay) {
            lastTime = now;
            fn.apply(this, args);
        }
    }
}

export default throttling